import styles from './ImageTextSection.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class ImageTextSection extends CustomComponent {
    constructor() {
        super();
        this.customStyle = styles;
    }

    get color(): string {
        return this.dataset.color ?? 'white';
    }

    get alignMedia(): string {
        return this.dataset.alignMedia ?? 'left';
    }

    get isVideo(): boolean {
        return this.querySelector('[slot=video]') !== null;
    }

    render() {
        const imageTextSectionContainer = document.createElement('div');
        imageTextSectionContainer.classList.add(`image-text-section`, `color-${this.color}`, `align-media-${this.alignMedia}`);
        imageTextSectionContainer.innerHTML = `
            <div class="media ${`media-${this.isVideo ? 'video' : 'image'}`}">
                <div class="media-frame">
                    <slot name="video"></slot>
                </div>
            </div>
            <div class="content-area">
                <div class="content">
                    <div class="overline"></div>
                    <div class="title"></div>
                    <div class="text-content"></div>
                    <div class="cta">
                        <slot name="cta"></slot>
                    </div>
                </div>
            </div>
      `;
        // Clone Slots into container to prevent styling issues
        this.cloneSlotContentIntoContainer(imageTextSectionContainer.querySelector('.overline'), 'overline');
        this.cloneSlotContentIntoContainer(imageTextSectionContainer.querySelector('.title'), 'title');
        this.cloneSlotContentIntoContainer(imageTextSectionContainer.querySelector('.media-frame'), 'media', false);
        this.cloneDefaultSlotContentIntoContainer(imageTextSectionContainer.querySelector('.text-content'));
        // Remove CTA if not set
        if (!this.querySelector('[slot=cta]')) {
            imageTextSectionContainer.querySelector('.cta').remove();
        }
        return imageTextSectionContainer;
    }

}

customElements.define('nxt-image-text-section', ImageTextSection);
